import { useSettings } from '@/hooks/useSettings'

export function PressMarquee() {
  const { press } = useSettings()
  const names = press?.names?.length ? press.names : ['Vogue', 'GQ', 'Elle', 'Byrdie', "Harper's Bazaar", 'Allure']

  return (
    <section className="overflow-hidden border-y border-line bg-card py-4">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...names, ...names, ...names].map((name, i) => (
          <span
            key={`${name}-${i}`}
            className="mx-10 font-condensed text-xs uppercase tracking-[0.2em] text-carbon/60"
          >
            {name}
          </span>
        ))}
      </div>
    </section>
  )
}
